<script setup lang="ts"></script>

<template>
    <header class="flex h-12 shrink-0 items-center gap-2 transition-[width,height] ease-linear">
        <div class="flex items-center gap-2 px-4">
            <slot></slot>
        </div>
    </header>
</template>
